import { render, staticRenderFns } from "./WorldMapAC.vue?vue&type=template&id=15601eba&scoped=true"
import script from "./WorldMapAC.vue?vue&type=script&lang=js"
export * from "./WorldMapAC.vue?vue&type=script&lang=js"
import style0 from "./WorldMapAC.vue?vue&type=style&index=0&id=15601eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15601eba",
  null
  
)

export default component.exports